import clsx from 'clsx';
import { Icon } from '@seeqdev/qomponents';
import type { Sort } from '@/trendData/trendData.constants';

interface SortIconProps extends Sort {
  sortProperty: string;
}

/** Icon to indicate sorting, e.g. table column headers */
export const SortIcon = ({ sortProperty, sortBy, sortAsc }: SortIconProps) => (
  <Icon
    testId={`sortProperty_${sortProperty}`}
    icon={clsx({
      'fa-sort-asc': sortBy === sortProperty && sortAsc,
      'fa-sort-desc': sortBy === sortProperty && !sortAsc,
      'fa-sort': sortBy !== sortProperty,
    })}
    type={sortBy === sortProperty ? 'info' : 'dark-gray'}
    extraClassNames="ml5 cursorPointer"
  />
);
